// extracted by mini-css-extract-plugin
export default {"Container":"VerifyCode_Container__0-tPn","CodeText":"VerifyCode_CodeText__1FjNR"};